document.addEventListener('DOMContentLoaded', function () {
	const links = document.querySelectorAll('.tech-focus-side-link');
	const sections = document.querySelectorAll('.tech-focus-side-content');
	sections.forEach((section, idx) => {
		const sectionObj = section;
		sectionObj.id = `side_tab${idx}`;
	});
	links.forEach((link, idx) => {
		const linkObj = link;
		linkObj.href = `#side_tab${idx}`;
	});

	// Get all tab links and tab content sections
	const tabLinks = document.querySelectorAll('.location-desktop .tabs li a');

	// Add event listener to each tab link
	tabLinks.forEach(tabLink => {
		tabLink.addEventListener('click', event => {
			event.preventDefault();

			// Remove 'active' class from all tab links and tab sections
			const selectedTabLinks = event.target
				.closest('.tabbed-content.tabs-side.location-desktop')
				?.querySelectorAll('.tabs li a');
			const selectedTabSections = event.target
				.closest('.tabbed-content.tabs-side.location-desktop')
				?.querySelectorAll('.item');

			selectedTabLinks.forEach(link => link.classList.remove('active'));
			selectedTabSections.forEach(section => section.classList.remove('active'));

			// Add 'active' class to the clicked tab link and corresponding tab section
			const clickedTab = event.target;
			const targetSectionId = clickedTab.getAttribute('href').substring(1);
			const targetSection = document.getElementById(targetSectionId);

			clickedTab.classList.add('active');
			targetSection.classList.add('active');
		});
	});

	const mobileLinks = document.querySelectorAll('.location-mobile section.item');
	mobileLinks.forEach(mobileLink => {
		mobileLink.addEventListener('click', event => {
			event.preventDefault();
			const clickedSec = event.target;
			if (String(clickedSec.classList).trim() === 'tech-focus-side-content item') {
				mobileLinks.forEach(mobLink => mobLink.classList.remove('active'));
				clickedSec.classList.add('active');
			} else if (String(clickedSec.classList).trim() === 'item') {
				mobileLinks.forEach(mobLink => mobLink.classList.remove('active'));
				clickedSec.classList.add('active');
			}
		});
	});
});
